/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */
//284-461




  // (function product_form() {
  //   function Json(element, events, options, module) {
  //     module.options.product = JSON.parse(element.innherHTML);
  //   };
  //
  //   function Self(element, event, options, module) {
  //     events.on("option:change", change);
  //
  //     function change() {
  //       var variant = get_variant(module.options.product, module.options.state.options);
  //
  //       if (variant ) {
  //         events.trigger("self:variantchange", [variant]);
  //         Events.trigger("productform:variantchange", [variant]);
  //       }
  //
  //       if( !variant ) {
  //         events.trigger("self:variantchangeunavailable");
  //         Events.trigger("productform:variantchangeunavailable");
  //       } else if ( variant.available ) {
  //         jQuery("#product_waiting_form").hide();
  //         jQuery(".ProductForm__QuantitySelector").show();
  //         jQuery(".ProductForm__AddToCart").show();
  //         events.trigger("self:variantchangeavailable", [variant]);
  //         Events.trigger("productform:variantchangeavailable", [variant]);
  //       } else {
  //         // back in stock form data - post hidden forms
  //         jQuery(".ProductForm__QuantitySelector").hide();
  //         jQuery(".ProductForm__AddToCart").hide();
  //
  //         jQuery("#mce-VARIANT").val(variant.title);
  //         jQuery("#mce-MMERGE4").val(variant.id);
  //         var url      = window.location.href;     // Returns full URL
  //         jQuery("#mce-URL").val(url);
  //           jQuery("#product_waiting_form").show();
  //           jQuery(".add-to-cart__wrapper").hide();
  //         // end back in stock form data - post hidden forms
  //         events.trigger("self:variantchangesoldout", [variant]);
  //         Events.trigger("productform:variantchangesoldout", [variant]);
  //       }
  //     }
  //   };
  // });


  jQuery(document).ready(function() {

    function clearActive(){
      tablinks = jQuery(".tablinks");
      for (i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(" active", "");
      }
    }


    jQuery('.womenTitle').click(function(){
      clearActive();
      jQuery('.womenTablinkCm').addClass('active');

      jQuery('#WomenCm').css('display', 'block');
      jQuery('#MenCm').css('display', 'none');


      jQuery('.womenSection').css('background-color', '#D2C5B2');
      jQuery('.menSection').css('background-color', 'white');
    });


    jQuery('.menTitle').click(function(){
      clearActive();
      jQuery('.menTablinkCm').addClass('active');

      jQuery('#MenCm').css('display', 'block');
      jQuery('#WomenCm').css('display', 'none');

      jQuery('.menSection').css('background-color', '#D2C5B2');
      jQuery('.womenSection').css('background-color', 'white');
    });



    jQuery('.womenTablinkIn').click(function() {
      clearActive();

      jQuery('.womenTablinkIn').addClass('active');

      jQuery('#MenIn').css('display', 'block');
      jQuery('#WomenIn').css('display', 'none');

      jQuery('.womenSection').css('background-color', '#D2C5B2');
      jQuery('.menSection').css('background-color', 'white');
    });

    jQuery('.menTablinkIn').click(function() {
      clearActive();

      jQuery('.menTablinkIn').addClass('active');

      jQuery('#WomenIn').css('display', 'block');
      jQuery('#MenIn').css('display', 'none');

      jQuery('.menSection').css('background-color', '#D2C5B2');
      jQuery('.womenSection').css('background-color', 'white');
    });





    jQuery('.womenTablinkCm').click(function() {
      clearActive();

      jQuery('.womenTablinkCm').addClass('active');

      jQuery('#WomenCm').css('display', 'block');
      jQuery('#MenCm').css('display', 'none');

      jQuery('.womenSection').css('background-color', '#D2C5B2');
      jQuery('.menSection').css('background-color', 'white');
    });

    jQuery('.menTablinkCm').click(function() {
      clearActive();

      jQuery('.menTablinkCm').addClass('active');

      jQuery('#MenCm').css('display', 'block');
      jQuery('#WomenCm').css('display', 'none');

      jQuery('.menSection').css('background-color', '#D2C5B2');
      jQuery('.womenSection').css('background-color', 'white');
    });


  });
(function () {
  var touchingCarousel = false,
    touchStartCoords;

  document.body.addEventListener('touchstart', function (e) {
    if (e.target.closest('.flickity-slider')) {
      touchingCarousel = true;
    } else {
      touchingCarousel = false;
      return;
    }

    touchStartCoords = {
      x: e.touches[0].pageX,
      y: e.touches[0].pageY
    }
  });

  document.body.addEventListener('touchmove', function (e) {
    if (!(touchingCarousel && e.cancelable)) {
      return;
    }

    var moveVector = {
      x: e.touches[0].pageX - touchStartCoords.x,
      y: e.touches[0].pageY - touchStartCoords.y
    };

    if (Math.abs(moveVector.x) > 7)
      e.preventDefault()

  }, {
    passive: false
  });
})();

jQuery(document).ready(function () {
  setTimeout(function () {
    var currentVariant = window.location;
    jQuery('.formProductUrl').attr("value", currentVariant);
    jQuery('.formProductUrl').val(currentVariant);
    jQuery('.ProductForm__Option--labelled input').click(function () {
      setTimeout(function () {
        var newVariant = window.location;
        jQuery('.formProductUrl').attr("value", newVariant);
        jQuery('.formProductUrl').val(newVariant);
      }, 300);
    });
  }, 300);
});
/* 
$('.ProductForm__AddToCart').click(function (){
  $('.Product__InfoWrapper').css('position','fixed')
  $('.Product__InfoWrapper').css('top','0')
});
$('.Drawer__Close').click(function (){
  $('.Product__InfoWrapper').css('position','sticky')
  $('.Product__InfoWrapper').css('top','73px')
}); */
$('.Collapsible__Button').click(function (event){
  $('.Collapsible__Button').each(function() {
    if ($(this)[0] != event.target) {
      $(this).find('.Collapsible_icon').removeClass('Collapsible_icon_open')
    }
  })
  $(this).find('.Collapsible_icon').toggleClass('Collapsible_icon_open')
});
